import React from 'react'
import '../../assets/css/style.scss'
import '../../assets/css/challange.scss'
import Host from '../Host'
import sampleImg1 from '../../assets/images/PlayerScreen/myPic.jpg'
import sampleImg2 from '../../assets/images/PlayerScreen/myPic1.png'


const Qauestions = () => {

const question = [
    {
        id:0,
        year:2017,
        left: '',
        right: '',
        background:" linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.375) 100%)",
   correctShadow:"",
   borderCard:"1.4px solid grey"
    },
    {
        id:1,
        year:2018,
        left: sampleImg1,
        right: '',
        background:" rgba(117, 209, 73, 0.6)",
    correctShadow:" 0px 0px 10.0001px #30AEBA, 0px 12px 40.0001px rgba(0, 0, 0, 0.75)",
    borderCard:"1.4px solid green"
    },
    {
        id:2,
        year:2019,
        left: '',
        right: sampleImg2,
        background:"rgba(242, 67, 130, 0.6)",
   correctShadow:"",
   borderCard:"1.4px solid grey"
    },
    {
        id:3,
        year:2020,
        left: '',
        right: '',
        background:" linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.375) 100%)",
    correctShadow:"",
    borderCard:"1.4px solid grey"
    }
]

    return (
        <>

            <div className="row " >

<div className="col-12 mt-4 d-flex justify-content-center text-light 1" style={{height:"9vh"}}>

<p className='py-2 px-4 ' style={{fontSize:"1.57vw", height:"100%", border:"1.4px solid orange", borderRadius:"12px"}}>What is the year Lionel Messi won a record sixth Ballon d'Or.</p>

</div>

<div className="col-12">

<div className="row px-4 my-3">

{
    question && question.map((item)=>{

return(

<div className="col-6 mb-3" style={{}}>

<div className={`py-3 d-flex justify-content-center `} style={{border:`${item.borderCard}`, borderRadius:"12px", background:`${item.background}`,  boxShadow:`${item.correctShadow}` }}>

<p className='mb-1 text-light' style={{fontSize:"1.4vw", fontWeight:"500"}}>{item.year}</p>


<div className='position-absolute' style={{ left:"10%", top:"22%"}} >

{
    item.left? <img style={{width:"2.7vw", height:"2.7vw", borderRadius:"50%", border:"2px solid green"}} src={item.left} alt="" /> : ''
}



</div>

<div className='position-absolute' style={{ right:"10%", top:"22%"}} >

{
    item.right? <img style={{width:"2.7vw", height:"2.7vw", borderRadius:"50%", border:"2px solid green"}} src={item.right} alt="" /> : ''
}



</div>

</div>

</div>

)

    })
}




    
</div>

</div>




                <div className="col-12 position-absolute text-light" style={{ top: "84.5%", left: "52.88%", transform: "translate(-50%, -50%)"  }}>

                    <Host />

                </div>

            </div>

        </>
    )
}

export default Qauestions